import React from 'react';
import { Link } from 'react-router-dom';
import { Mail, Phone, MapPin } from 'lucide-react';

const Footer = () => {
  const currentYear = new Date().getFullYear();

  return (
    <footer className="footer">
      <div className="container">
        <div className="footer-grid">
          {/* Brand Column */}
          <div className="footer-brand">
            <img 
              src="https://customer-assets.emergentagent.com/job_arvix-staging/artifacts/dh3jqtxi_image.png" 
              alt="Arvix Consulting Logo"
              style={{ height: '50px', marginBottom: '16px' }}
            />
            <p>
              Clarity across the product lifecycle. We deliver practical technology solutions that drive reliable results for modern businesses.
            </p>
          </div>

          {/* Quick Links */}
          <div>
            <h4 className="footer-title">Quick Links</h4>
            <ul className="footer-links">
              <li><Link to="/" data-testid="footer-home">Home</Link></li>
              <li><Link to="/about" data-testid="footer-about">About Us</Link></li>
              <li><Link to="/services" data-testid="footer-services">Services</Link></li>
              <li><Link to="/contact" data-testid="footer-contact">Contact</Link></li>
            </ul>
          </div>

          {/* Services */}
          <div>
            <h4 className="footer-title">Services</h4>
            <ul className="footer-links">
              <li><Link to="/services#web-development" data-testid="footer-web-dev">Web Development</Link></li>
              <li><Link to="/services#hosting" data-testid="footer-hosting">Website Hosting</Link></li>
              <li><Link to="/services#software" data-testid="footer-software">Custom Software</Link></li>
              <li><Link to="/services#marketing" data-testid="footer-digital">Digital Marketing</Link></li>
            </ul>
          </div>

          {/* Contact Info */}
          <div>
            <h4 className="footer-title">Contact Us</h4>
            <div className="footer-contact-item">
              <Mail size={18} />
              <a href="mailto:info@arvixconsulting.in" data-testid="footer-email">info@arvixconsulting.in</a>
            </div>
            <div className="footer-contact-item">
              <Phone size={18} />
              <a href="tel:+919766875553" data-testid="footer-phone">+91 97668 75553</a>
            </div>
            <div className="footer-contact-item">
              <MapPin size={18} />
              <span>Pune-Alandi Road, Dighi, India</span>
            </div>
          </div>
        </div>

        {/* Footer Bottom */}
        <div className="footer-bottom">
          <p>© {currentYear} Arvix Consulting. All rights reserved.</p>
          <div className="footer-social">
            <a 
              href="https://www.linkedin.com/company/arvix-consulting" 
              target="_blank" 
              rel="noopener noreferrer"
              aria-label="LinkedIn"
              data-testid="footer-linkedin"
            >
              <i className="fab fa-linkedin-in"></i>
            </a>
            <a 
              href="https://twitter.com" 
              target="_blank" 
              rel="noopener noreferrer"
              aria-label="Twitter"
              data-testid="footer-twitter"
            >
              <i className="fab fa-twitter"></i>
            </a>
          </div>
        </div>
      </div>
    </footer>
  );
};

export default Footer;
